import { OptionDto } from "@/dtos";
import { TripPatternOrientation } from "@/helpers/types";

const orientations = [
    { value: TripPatternOrientation.OUTBOUND, label: 'Ida' },
    { value: TripPatternOrientation.INBOUND, label: 'Retorno' },
    { value: TripPatternOrientation.CIRCULAR, label: 'Circular' },
] as OptionDto[];

export const getTripPatternOrientationOptions = (): OptionDto[] => {
    return orientations;
}

export const getTripPatternOrientationOption = (value?: number): OptionDto => {
    return orientations.find((x) => x.value == value) ?? orientations[0];
}

export const getTripPatternOrientationLabel = (value: number): string => {
    return orientations.find((x) => x.value == value)?.label ?? orientations[0].label;
}